import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import CompanyAddress from "../../entity/user/CompanyAddress";

const SERVICE = "service-user";
const ENTITY = "company_addresses";

export default function () {
    const {findOneBy, create, update} = useApi();
    const state = useSelector;
    const newInstance = data => new CompanyAddress(data);

    return {
        findOneById(id) {
            return {
                select() {

                    const result = state(state => state.api?.user?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findOneBy(SERVICE, ENTITY, "id", id, newInstance, "entrepreneur");
                }
            }
        },
        findOneByCompanyId(id) {
            return {
                select() {

                    const result = state(state => state.api?.user?.[ENTITY]?.find(ca => ca?.getCompanyId() == id));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findOneBy(SERVICE, ENTITY, "company_id", id, newInstance, "entrepreneur");
                }
            }
        },
        async update(id, property, payload) {
            update(SERVICE, ENTITY, id, property, payload, newInstance, "entrepreneur");
        }
    }
}